module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-two.1d443607.png";